import actions from '../action/me'
import CONSTANT from '../constant/me'

const meDetail = {}
const pageData = {}
const feedbackStatus = {}
const noWatchCount = {
  today: {
    count: 0
  },
  all: {
    count: 0
  }
}
export default {
  actions,
  state: {
    meDetail,
    pageData,
    feedbackStatus,
    noWatchCount,
  },
  mutations: {
    [CONSTANT.ME_GET_DETAIL_SUCCESS] (state, data) {
      return state.meDetail = data
    },
    [CONSTANT.ME_GET_DETAIL_ERROR] (state, e) {
      return state.meDetail = {}
    },
    [CONSTANT.ME_GET_PAGE_SUCCESS] (state, data) {
      return state.pageData = data
    },
    [CONSTANT.ME_GET_PAGE_ERROR] (state, e) {
      return state.pageData = {}
    },
    [CONSTANT.ME_DETAIL_CHANGE_NICKNAME] (state, data) {
      return state.meDetail.nickName = data.nickName
    },
    [CONSTANT.ME_DETAIL_CHANGE_GENDER] (state, data) {
      return state.meDetail.gender = data.gender
    },
    [CONSTANT.ME_DETAIL_CHANGE_BIRTHDAY] (state, data) {
      return state.meDetail.birthday = data.birthday
    },
    [CONSTANT.ME_DETAIL_CHANGE_HEADICON] (state, data) {
      return state.meDetail.headIcon = data.headIcon
    },

    [CONSTANT.ME_FEEDBACK_SUCCESS] (state, data) {
      return state.feedback = data
    },
    [CONSTANT.ME_FEEDBACK_ERROR] (state, e) {
      return state.feedback = e
    },
    [CONSTANT.ME_NO_WATCH_COUNT_SUCCESS] (state, data) {
      return state.noWatchCount = data
    },
    [CONSTANT.ME_NO_WATCH_COUNT_ERROR] (state, e) {
      return state.noWatchCount = {
        today: {count: 0},
        all: {count: 0}
      }
    },
  },
  getters: {
    [CONSTANT.ME_GETTER_GET_DETAIL] (state, getters, rootState) {
      return state.meDetail
    }
  }
}
